<template>
  <div class="payment-success">
    <h1>Payment Successful!</h1>

    <p>
      Order ID: <strong>{{ orderId }}</strong><br>
      Amount Paid: <strong>₹{{ orderAmount }}</strong>
    </p>

    <p v-if="loading">
      Loading your updated credit balance…
    </p>
    <p v-else-if="error" class="error">
      {{ error }}
    </p>
    <p v-else>
      Your new credit balance is 
      <strong>₹{{ creditBalance }}</strong>.
    </p>

    <router-link to="/ask-ai">Return to AI</router-link>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'PaymentSuccess',
  data() {
    return {
      orderId: null,
      orderAmount: null,
      creditBalance: null,
      loading: true,
      error: null
    };
  },
  created() {
    // Pull both order_id and order_amount from query params
    this.orderId     = this.$route.query.order_id     || '—';
    this.orderAmount = this.$route.query.order_amount || '—';
  },
  async mounted() {
    try {
      // Fetch updated profile (includes credit_balance)
      const { data } = await api.get('/auth/me');
      this.creditBalance = data.credit_balance;
      // Save to localStorage for other pages
      localStorage.setItem('credit_balance', data.credit_balance);
    } catch (err) {
      console.error('🔄 Balance refresh failed:', err);
      this.error = 'Could not refresh your credit balance. Please try again later.';
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.payment-success {
  max-width: 600px;
  margin: 80px auto;
  text-align: center;
}
.error {
  color: red;
}
</style>
